import {ChevronDownIcon} from "@heroicons/react/20/solid";
import React from "react";
import TagButton, {TagButtonProps} from "./tag-button";

export type TagMenuButtonProps = {startElement?: React.ReactNode; endElement?: never} & TagButtonProps;

const TagMenuButton = React.forwardRef<HTMLButtonElement, TagButtonProps>((props, ref) => {
  return <TagButton ref={ref} {...props} endElement={!props.disabled && <ChevronDownIcon />} />;
});

export default TagMenuButton;
